import {stateData, reduxState} from '../../values';

export const getAdmins = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_admin,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateAdmin = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_admin,
            payload:    data,
        })
    }
}